import { memo, useEffect, useMemo } from 'react';

import { StructuredSurvey, StructuredSurveyTemplate } from '@dreryk/egabinet-survey-frontend-api';

import { StyledFlex } from '@dreryk/react-components';

import { useMedicalProfileFormContext } from '../MedicalProfileFormContext';
import { SectionRow } from '../section/SectionRow';

import { mapTabViewModel } from './MedicalProfileTab.utils';

type MedicalProfileTabProps = {
   readonly templateCode: string;
   readonly template: StructuredSurveyTemplate;
   readonly structuredSurvey: StructuredSurvey | null;
   readonly expandedSectionId?: number;
};

export const MedicalProfileTab = memo(
   (props: MedicalProfileTabProps): JSX.Element => {
      const { registerViewModel } = useMedicalProfileFormContext();
      const viewModel = useMemo(() => mapTabViewModel(props.templateCode, props.template, props.structuredSurvey), [
         props.templateCode,
         props.template,
         props.structuredSurvey,
      ]);

      useEffect(() => {
         registerViewModel(viewModel);
      }, [registerViewModel, viewModel]);

      return (
         <StyledFlex direction={'column'}>
            {viewModel.rows.map((row) => (
               <SectionRow
                  key={row.sectionId}
                  templateCode={props.templateCode}
                  template={props.template}
                  initialAnswers={viewModel.initialAnswers}
                  row={row}
                  expandedSectionId={props.expandedSectionId}
               />
            ))}
         </StyledFlex>
      );
   }
);
